import { ChangeEvent } from 'react';
import { Stack, Box, Typography, FormControlLabel, Switch, TextField } from '@mui/material';
import { useI18nContext } from '@/i18n/i18n-react';
import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { updateFormData } from '@/store/installSlice';

export const ScheduleStep = () => {
    const { LL } = useI18nContext();
    const dispatch = useAppDispatch();
    const formData = useAppSelector((state) => state.install.formData);

    const handleChange = (field: string) => (e: ChangeEvent<HTMLInputElement>) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        dispatch(updateFormData({ [field]: value }));
    };

    return (
        <Stack spacing={3}>
            <Box>
                <Typography
                    variant="body2"
                    sx={{
                        color: 'text.secondary',
                        mb: 2,
                    }}
                >
                    {LL.install.schedule.description()}
                </Typography>
                <FormControlLabel
                    control={
                        <Switch
                            checked={formData.scheduleEnabled}
                            onChange={handleChange('scheduleEnabled')}
                        />
                    }
                    label={LL.install.schedule.enable()}
                />
            </Box>
            {formData.scheduleEnabled && (
                <>
                    <TextField
                        label={LL.install.schedule.minDuration()}
                        type="number"
                        value={formData.scheduleMinDuration}
                        onChange={handleChange('scheduleMinDuration')}
                        fullWidth
                    />

                    <TextField
                        label={LL.install.schedule.defaultStartTime()}
                        type="time"
                        value={formData.scheduleDefaultStartTime}
                        onChange={handleChange('scheduleDefaultStartTime')}
                        fullWidth
                        slotProps={{ inputLabel: { shrink: true } }}
                    />

                    <TextField
                        label={LL.install.schedule.defaultSetupTime()}
                        type="number"
                        value={formData.scheduleDefaultSetupTime}
                        onChange={handleChange('scheduleDefaultSetupTime')}
                        fullWidth
                    />

                    <TextField
                        label={LL.install.schedule.defaultTeardownTime()}
                        type="number"
                        value={formData.scheduleDefaultTeardownTime}
                        onChange={handleChange('scheduleDefaultTeardownTime')}
                        fullWidth
                    />
                </>
            )}
        </Stack>
    );
};
